import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var BrandListRes;
export const BrandListTodo = createAsyncThunk('BrandList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'vehicle_brand',
            params:{
                "vehicle_brand_status ": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return BrandListRes = res.data

    } catch (error) {
        return BrandListRes = error.response.data
    }
})

const BrandListSlice = createSlice({
    name: 'BrandList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(BrandListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(BrandListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default BrandListSlice.reducer; 